<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Import Notification Recipients</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Table List -->
    <form @submit.prevent="save">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-2">
              <h4 class="mt-2">Import Type</h4>
            </div>
            <div class="col-md-4">
              <select
                class="form-control"
                v-model="importType"
                @change="changeImportType"
              >
                <option value="automation">Automation</option>
                <option value="manual">Manual</option>
              </select>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-4 mr-5">
              <table class="table table-bordered custom-table mb-0">
                <thead class="thead-light">
                  <tr>
                    <th class="text-center">To Recipients</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in toRecipients" :key="item.Id">
                    <td class="text-center" style="position: relative">
                      <input
                        type="email"
                        v-model="item.Email"
                        class="form-control height26 text-center"
                        required
                      />
                      <span
                        @click="removeToRecipient(i)"
                        style="
                          position: absolute;
                          right: -8px;
                          top: 10px;
                          color: #ff0000;
                          cursor: pointer;
                        "
                      >
                        <i class="fa fa-minus-circle"></i>
                      </span>
                    </td>
                  </tr>
                  <tr v-for="(newItem, i) in newToRecipients" :key="i">
                    <td class="text-center" style="position: relative">
                      <input
                        type="email"
                        v-model="newItem.Email"
                        class="form-control height26 text-center"
                        required
                      />
                      <span
                        @click="removeNewToRecipient(i)"
                        style="
                          position: absolute;
                          right: -8px;
                          top: 10px;
                          color: #ff0000;
                          cursor: pointer;
                        "
                      >
                        <i class="fa fa-minus-circle"></i>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="addToRecipient"
                      >
                        <i class="fa fa-plus"></i> Add Email
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-md-4">
              <table class="table table-bordered custom-table mb-0">
                <thead class="thead-light">
                  <tr>
                    <th class="text-center">Cc Recipients</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in ccRecipients" :key="item.Id">
                    <td class="text-center" style="position: relative">
                      <input
                        type="email"
                        v-model="item.Email"
                        class="form-control height26 text-center"
                        required
                      />
                      <span
                        @click="removeCcRecipient(i)"
                        style="
                          position: absolute;
                          right: -8px;
                          top: 10px;
                          color: #ff0000;
                          cursor: pointer;
                        "
                      >
                        <i class="fa fa-minus-circle"></i>
                      </span>
                    </td>
                  </tr>
                  <tr v-for="(newItem, i) in newCcRecipients" :key="i">
                    <td class="text-center" style="position: relative">
                      <input
                        type="email"
                        v-model="newItem.Email"
                        class="form-control height26 text-center"
                        required
                      />
                      <span
                        @click="removeNewCcRecipient(i)"
                        style="
                          position: absolute;
                          right: -8px;
                          top: 10px;
                          color: #ff0000;
                          cursor: pointer;
                        "
                      >
                        <i class="fa fa-minus-circle"></i>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="addCcRecipient"
                      >
                        <i class="fa fa-plus"></i> Add Email
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <button type="submit" class="btn btn-primary">
            <i class="fa fa-save"></i>
            Save
          </button>
        </div>
      </div>
    </form>
    <!-- /Table List -->
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  data() {
    return {
      importType: "automation",
      toRecipients: [],
      newToRecipients: [],
      ccRecipients: [],
      newCcRecipients: [],
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },
  methods: {
    addToRecipient() {
      this.newToRecipients.push({
        Id: "",
        Email: "",
      });
    },
    addCcRecipient() {
      this.newCcRecipients.push({
        Id: "",
        Email: "",
      });
    },
    removeToRecipient(index) {
      this.toRecipients.splice(index, 1);
    },
    removeNewToRecipient(index) {
      this.newToRecipients.splice(index, 1);
    },
    removeCcRecipient(index) {
      this.ccRecipients.splice(index, 1);
    },
    removeNewCcRecipient(index) {
      this.newCcRecipients.splice(index, 1);
    },
    changeImportType() {
      this.getRecipients();
    },
    getRecipients() {
      let param = {
        Token: this.token,
        ImportType: this.importType,
      };
      this.$store.state.isLoading = true;
      API.getImportNotificationRecipients(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.toRecipients = response.data.toRecipients;
            this.ccRecipients = response.data.ccRecipients;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    save() {
      //check duplicate to recipients
      let allToRecipients = this.toRecipients.concat(this.newToRecipients);
      for (let item of allToRecipients) {
        if (item.Email) {
          let records = allToRecipients.filter((c) => c.Email == item.Email);
          if (records && records.length > 1) {
            alert(`To Email: ${item.Email} is duplicated.`);
            return;
          }
        }
      }
      //check duplicate cc recipients
      let allCcRecipients = this.ccRecipients.concat(this.newCcRecipients);
      for (let item of allCcRecipients) {
        if (item.Email) {
          let records = allCcRecipients.filter((c) => c.Email == item.Email);
          if (records && records.length > 1) {
            alert(`Cc Email: ${item.Email} is duplicated.`);
            return;
          }
        }
      }

      let param = {
        Token: this.token,
        ImportType: this.importType,
        ToRecipients: this.toRecipients,
        NewToRecipients: this.newToRecipients,
        CcRecipients: this.ccRecipients,
        NewCcRecipients: this.newCcRecipients,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the email?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveImportNotificationRecipients(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              this.toRecipients = [];
              this.newToRecipients = [];
              this.ccRecipients = [];
              this.newCcRecipients = [];
              this.getRecipients();
            })
            .catch((error) => {
              console.log(error);
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
  },
  created() {
    if (this.role != "admin")
      this.$router.replace({ name: "home" });
    this.getRecipients();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Attendance/CADONotificationRecipient.vue